import { hasChildren } from "shared/lib/hasChildren"
import { TreeNode } from "shared/types/TreeNode"
import { WithID } from "shared/types/WithID"

import { FlattenedTableItemType } from "../types"

export function getFlattenedTree<T extends WithID>(
  nodes: TreeNode<T>[] | null | undefined = [],
  collapsedNodes: string[] = [],
  parents: string[] = [],
  parentIndices: number[] = []
): TreeNode<FlattenedTableItemType<T>>[] {
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  return (
    nodes?.reduce(
      (flattenedTree: FlattenedTableItemType[], node: TreeNode<T>, index) => {
        const level = parents.length
        const nodeWithHelpers: FlattenedTableItemType = {
          ...node,
          childIDs: node.children?.map(child => child.id) || null,
          siblingCount: nodes.length,
          position: index,
          level,
          parents,
          parentIndices: [...parentIndices, index]
        }

        if (!hasChildren(node) || collapsedNodes.includes(node.id)) {
          return [...flattenedTree, nodeWithHelpers]
        }

        return [
          ...flattenedTree,
          nodeWithHelpers,
          ...getFlattenedTree(
            node.children,
            collapsedNodes,
            [...parents, node.id],
            [...parentIndices, index]
          )
        ]
      },
      [] as FlattenedTableItemType<T>[]
    ) || []
  )
}
